(()=>{const q=(s,c=document)=>c.querySelector(s),qa=(s,c=document)=>[...c.querySelectorAll(s)];document.documentElement.classList.remove('no-js');const header=q('[data-yv3-header]'),menu=q('[data-yv3-menu]'),mobile=q('[data-yv3-mobile]');if(menu&&mobile)menu.addEventListener('click',()=>{const open=mobile.classList.toggle('is-open');menu.classList.toggle('is-open',open);menu.setAttribute('aria-expanded',open?'true':'false');document.body.classList.toggle('yv3-menu-open',open)});if(header){const f=()=>header.classList.toggle('is-scrolled',scrollY>24);f();addEventListener('scroll',f,{passive:true})}const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches,items=qa('.yv3-reveal');if(!reduce&&'IntersectionObserver'in window){const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-visible');io.unobserve(e.target)}}),{threshold:.1,rootMargin:'0px 0px -4%'});items.forEach((el,i)=>{el.style.setProperty('--delay',`${(i%5)*55}ms`);io.observe(el)})}else items.forEach(el=>el.classList.add('is-visible'));const par=q('[data-yv3-parallax]');if(par&&!reduce){let tick=false;addEventListener('scroll',()=>{if(!tick){requestAnimationFrame(()=>{par.style.transform=`scale(1.05) translate3d(0,${Math.min(scrollY*.07,55)}px,0)`;tick=false});tick=true}},{passive:true})}const glow=q('[data-yv3-glow]');if(glow&&!reduce&&matchMedia('(pointer:fine)').matches)addEventListener('pointermove',e=>{glow.style.setProperty('--x',`${e.clientX}px`);glow.style.setProperty('--y',`${e.clientY}px`);glow.classList.add('is-on')},{passive:true});const canvas=q('[data-yv3-snow]');if(canvas&&!reduce){const ctx=canvas.getContext('2d');let flakes=[],w=0,h=0,dpr=Math.min(devicePixelRatio||1,2),raf;const size=()=>{w=canvas.clientWidth;h=canvas.clientHeight;canvas.width=w*dpr;canvas.height=h*dpr;ctx.setTransform(dpr,0,0,dpr,0,0);flakes=Array.from({length:Math.min(90,Math.floor(w/14))},()=>({x:Math.random()*w,y:Math.random()*h,r:Math.random()*1.6+.3,s:Math.random()*.4+.15,d:Math.random()*.25-.125,a:Math.random()*.5+.12}))};const draw=()=>{ctx.clearRect(0,0,w,h);for(const f of flakes){f.y+=f.s;f.x+=f.d;if(f.y>h+5){f.y=-5;f.x=Math.random()*w}ctx.globalAlpha=f.a;ctx.beginPath();ctx.arc(f.x,f.y,f.r,0,Math.PI*2);ctx.fillStyle='#fff';ctx.fill()}raf=requestAnimationFrame(draw)};size();draw();addEventListener('resize',size,{passive:true});document.addEventListener('visibilitychange',()=>{if(document.hidden)cancelAnimationFrame(raf);else draw()})}qa('[data-yv3-thumb]').forEach(btn=>btn.addEventListener('click',()=>{const main=q('[data-yv3-main-image]');if(main){main.src=btn.dataset.src;main.srcset='';main.alt=btn.dataset.alt||main.alt;qa('[data-yv3-thumb]').forEach(x=>x.classList.remove('is-active'));btn.classList.add('is-active')}}));qa('[data-yv3-variant-select]').forEach(select=>select.addEventListener('change',()=>{const o=select.options[select.selectedIndex],price=q('[data-yv3-price]'),add=q('[data-yv3-add]');if(price&&o.dataset.price)price.textContent=o.dataset.price;if(add){const ok=o.dataset.available==='true';add.disabled=!ok;const s=add.querySelector('span');if(s)s.textContent=ok?'ADD TO BAG':'SOLD OUT'}}));})();

/* Yeti V3.1 MAX FX */
(()=>{
  const q=(s,c=document)=>c.querySelector(s), qa=(s,c=document)=>[...c.querySelectorAll(s)];
  const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
  const coarse=matchMedia('(pointer:coarse)').matches;
  if(reduce) return;

  /* scroll progress + section ambient position */
  const progress=q('[data-yv3-progress]');
  let scrollTick=false;
  const onScroll=()=>{
    if(scrollTick)return; scrollTick=true;
    requestAnimationFrame(()=>{
      if(progress){const d=document.documentElement;const max=Math.max(1,d.scrollHeight-innerHeight);progress.style.transform=`scaleX(${Math.min(1,scrollY/max)})`}
      qa('.yv3-section,.yv3-finder,.yv3-kits').forEach(el=>{const r=el.getBoundingClientRect();const x=Math.max(10,Math.min(90,50+(r.top/Math.max(innerHeight,1))*10));el.style.setProperty('--section-x',x+'%')});
      scrollTick=false;
    });
  }; addEventListener('scroll',onScroll,{passive:true}); onScroll();

  /* pointer world coordinates */
  addEventListener('pointermove',e=>{document.body.style.setProperty('--mx',e.clientX+'px');document.body.style.setProperty('--my',e.clientY+'px')},{passive:true});

  /* product 3D tilt on fine pointers */
  if(!coarse){
    qa('.yv3-product-card').forEach(card=>{
      const media=q('.yv3-product-card__media',card);
      card.addEventListener('pointermove',e=>{
        const r=card.getBoundingClientRect(),x=(e.clientX-r.left)/r.width,y=(e.clientY-r.top)/r.height;
        card.style.setProperty('--ry',((x-.5)*8).toFixed(2)+'deg');
        card.style.setProperty('--rx',((.5-y)*7).toFixed(2)+'deg');
        card.style.setProperty('--shine-x',(x*100).toFixed(1)+'%');
        card.style.setProperty('--shine-y',(y*100).toFixed(1)+'%');
        card.classList.add('is-tilting');
        if(media){media.style.setProperty('--shine-x',(x*100).toFixed(1)+'%');media.style.setProperty('--shine-y',(y*100).toFixed(1)+'%')}
      });
      card.addEventListener('pointerleave',()=>{card.classList.remove('is-tilting');card.style.setProperty('--rx','0deg');card.style.setProperty('--ry','0deg')});
    });

    qa('.yv3-category-panel').forEach(panel=>panel.addEventListener('pointermove',e=>{const r=panel.getBoundingClientRect();panel.style.setProperty('--px',((e.clientX-r.left)/r.width*100)+'%');panel.style.setProperty('--py',((e.clientY-r.top)/r.height*100)+'%')}));

    /* restrained magnetic movement */
    qa('.yv3-btn').forEach(btn=>{
      btn.addEventListener('pointermove',e=>{const r=btn.getBoundingClientRect(),x=e.clientX-r.left-r.width/2,y=e.clientY-r.top-r.height/2;btn.style.transform=`translate3d(${x*.06}px,${y*.08}px,0)`});
      btn.addEventListener('pointerleave',()=>btn.style.transform='');
    });
  }

  /* click/tap ripple */
  qa('.yv3-btn,.yv3-mini-btn').forEach(btn=>btn.addEventListener('pointerdown',e=>{const r=btn.getBoundingClientRect(),dot=document.createElement('i');dot.className='yv3-ripple';dot.style.left=(e.clientX-r.left)+'px';dot.style.top=(e.clientY-r.top)+'px';btn.appendChild(dot);setTimeout(()=>dot.remove(),700)}));

  /* subtle hero text depth from pointer / device movement */
  const hero=q('[data-yv3-hero]'),copy=q('.yv3-hero__copy'),statement=q('.yv3-hero__statement');
  if(hero && !coarse){hero.addEventListener('pointermove',e=>{const r=hero.getBoundingClientRect(),x=(e.clientX-r.left)/r.width-.5,y=(e.clientY-r.top)/r.height-.5;if(copy)copy.style.transform=`translate3d(${x*-8}px,${y*-5}px,0)`;if(statement)statement.style.transform=`translate3d(${x*12}px,${y*8}px,0)`});hero.addEventListener('pointerleave',()=>{if(copy)copy.style.transform='';if(statement)statement.style.transform=''})}
})();

/* Yeti V3.7 — campfire-sourced natural smoke.
   One continuous plume rises from the base-camp fire. Soft expanding smoke
   parcels follow a smooth turbulent airflow instead of burst particles or
   fixed snake-like paths. The canvas is independent from DOM compositing. */
(()=>{
  const canvas=document.querySelector('[data-yv3-fire-smoke]');
  const source=document.querySelector('[data-yv3-fire-source]');
  if(!canvas || !source || matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const ctx=canvas.getContext('2d',{alpha:true,desynchronized:true});
  if(!ctx) return;

  let w=1,h=1,dpr=1,last=0,raf=0,spawnAcc=0,particles=[];
  let mobile=matchMedia('(max-width: 760px)').matches;
  const TAU=Math.PI*2;
  const rnd=(a,b)=>a+Math.random()*(b-a);

  function makeSprite(seed){
    const c=document.createElement('canvas'); c.width=c.height=128;
    const x=c.getContext('2d');
    x.clearRect(0,0,128,128);
    const lobes=7;
    for(let i=0;i<lobes;i++){
      const a=(seed*1.7+i*2.399)%TAU;
      const cx=64+Math.cos(a)*rnd(5,19), cy=64+Math.sin(a)*rnd(4,16);
      const r=rnd(31,53);
      const g=x.createRadialGradient(cx,cy,0,cx,cy,r);
      g.addColorStop(0,'rgba(242,248,249,.25)');
      g.addColorStop(.33,'rgba(224,236,239,.12)');
      g.addColorStop(.72,'rgba(199,218,223,.035)');
      g.addColorStop(1,'rgba(190,210,216,0)');
      x.fillStyle=g; x.beginPath(); x.arc(cx,cy,r,0,TAU); x.fill();
    }
    return c;
  }
  const sprites=[makeSprite(.17),makeSprite(.61),makeSprite(1.13),makeSprite(1.91)];

  function resize(){
    mobile=matchMedia('(max-width: 760px)').matches;
    w=Math.max(1,innerWidth); h=Math.max(1,innerHeight);
    dpr=Math.min(devicePixelRatio||1,mobile?1.15:1.45);
    canvas.width=Math.round(w*dpr); canvas.height=Math.round(h*dpr);
    canvas.style.width=w+'px'; canvas.style.height=h+'px';
    ctx.setTransform(dpr,0,0,dpr,0,0);
    ctx.clearRect(0,0,w,h);
    particles=[];
  }

  function emitter(){
    const r=source.getBoundingClientRect();
    const x=Math.max(0,Math.min(w,r.left+r.width*.5));
    /* Until the camp scene reaches the viewport, the plume enters naturally
       from just below the bottom edge. Once visible, it locks to the fire. */
    const fireY=r.top+r.height*.5;
    const y=(r.top<h+40 && r.bottom>-40) ? fireY : h+28;
    return {x,y};
  }

  function spawn(e){
    const count=mobile?1:(Math.random()<.48?2:1);
    for(let i=0;i<count;i++){
      particles.push({
        x:e.x+rnd(-5,5), y:e.y+rnd(-2,7),
        vx:rnd(-2.6,2.6), vy:rnd(-34,-25),
        age:0, life:rnd(mobile?15:17,mobile?20:23),
        size:rnd(mobile?13:15,mobile?20:23),
        grow:rnd(mobile?3.0:3.5,mobile?4.4:5.1),
        phase:rnd(0,TAU), phase2:rnd(0,TAU),
        curl:rnd(.78,1.18), drift:rnd(-.55,.55),
        alpha:rnd(.56,.92), sprite:sprites[Math.floor(Math.random()*sprites.length)],
        rot:rnd(0,TAU), spin:rnd(-.055,.055), stretch:rnd(1.05,1.5)
      });
    }
  }

  function draw(now){
    if(!last) last=now;
    const dt=Math.min(.05,(now-last)/1000); last=now;
    ctx.clearRect(0,0,w,h);
    const e=emitter();
    spawnAcc+=dt;
    const every=mobile?.115:.078;
    while(spawnAcc>every){spawnAcc-=every;spawn(e)}

    const t=now/1000;
    const next=[];
    for(const p of particles){
      p.age+=dt;
      const u=p.age/p.life;
      if(u>=1 || p.y<-180 || p.x<-220 || p.x>w+220) continue;

      /* Broad meander + smaller eddies. The forces change smoothly with time
         and height, so the plume folds, opens and curls instead of oscillating
         like a repeating sine-wave snake. */
      const heightFactor=Math.max(0,Math.min(1,1-p.y/Math.max(h,1)));
      const broad=Math.sin(t*.34+p.phase+p.y*.0035);
      const eddy=Math.sin(t*.73+p.phase2-p.y*.0105);
      const fine=Math.cos(t*.29-p.phase*.7+p.y*.021);
      const side=(broad*8.5+eddy*4.7+fine*1.9)*p.curl*(.38+heightFactor*.92)+p.drift;
      p.vx+=(side-p.vx*.14)*dt;
      p.vx=Math.max(-22,Math.min(22,p.vx));
      p.vy-=1.2*dt;
      p.x+=p.vx*dt;
      p.y+=p.vy*dt;
      p.rot+=p.spin*dt*20;

      const fadeIn=Math.min(1,u/.10);
      const fadeOut=Math.min(1,(1-u)/.28);
      const alpha=fadeIn*fadeOut*p.alpha*(mobile?.115:.135);
      const size=p.size+p.grow*p.age;
      const stretch=p.stretch+u*.72;

      ctx.save();
      ctx.translate(p.x,p.y);
      ctx.rotate(p.rot);
      ctx.scale(1,stretch);
      ctx.globalAlpha=alpha;
      ctx.drawImage(p.sprite,-size*.5,-size*.5,size,size);
      ctx.restore();
      next.push(p);
    }
    particles=next;
    raf=requestAnimationFrame(draw);
  }

  resize();
  addEventListener('resize',resize,{passive:true});
  document.addEventListener('visibilitychange',()=>{
    if(document.hidden){cancelAnimationFrame(raf)}
    else{last=performance.now();raf=requestAnimationFrame(draw)}
  });
  raf=requestAnimationFrame(draw);
})();

/* Yeti Scrubs V4.2R — depth-aware full-screen snowfall + campfire-sourced rolling smoke */
(()=>{
  const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(reduce) return;
  const snow=document.querySelector('[data-yv4-global-snow]');
  if(snow){
    const c=snow.getContext('2d',{alpha:true,desynchronized:true});
    let w=1,h=1,dpr=1,flakes=[],raf=0,last=0;
    const mobile=()=>matchMedia('(max-width:749px)').matches;
    const rnd=(a,b)=>a+Math.random()*(b-a);
    function makeFlake(){
      const depth=Math.random();
      const near=depth>.82, far=depth<.38;
      return {
        x:Math.random()*w,y:Math.random()*h,depth,
        r:far?rnd(.35,1.05):near?rnd(2.2,4.8):rnd(.9,2.25),
        vy:far?rnd(.28,.62):near?rnd(1.25,2.25):rnd(.62,1.25),
        vx:rnd(-.22,.18),a:far?rnd(.16,.38):near?rnd(.42,.72):rnd(.28,.56),
        phase:rnd(0,Math.PI*2),wobble:rnd(.004,.011),spin:rnd(-.018,.018),angle:rnd(0,Math.PI*2),
        streak:near && Math.random()<.22
      };
    }
    function resize(){
      w=innerWidth;h=innerHeight;dpr=Math.min(devicePixelRatio||1,mobile()?1.15:1.5);
      snow.width=Math.round(w*dpr);snow.height=Math.round(h*dpr);snow.style.width=w+'px';snow.style.height=h+'px';
      c.setTransform(dpr,0,0,dpr,0,0);
      const count=Math.min(mobile()?115:235,Math.floor(w*(mobile()?.23:.21)));
      flakes=Array.from({length:count},makeFlake);
    }
    function respawn(f){f.y=-12;f.x=Math.random()*w;f.phase=rnd(0,Math.PI*2)}
    function draw(t){
      const dt=Math.min(2,(t-last)/16.67||1);last=t;c.clearRect(0,0,w,h);
      const gust=(window.__yv4Wind||0)*1.35;
      for(const f of flakes){
        f.phase+=f.wobble*dt;f.angle+=f.spin*dt;
        const sway=Math.sin(f.phase+t*.00023)*(0.11+f.depth*.38);
        f.x+=(f.vx+sway+gust*(.35+f.depth))*dt;f.y+=f.vy*dt;
        if(f.y>h+14)respawn(f);if(f.x<-18)f.x=w+16;if(f.x>w+18)f.x=-16;
        c.save();c.translate(f.x,f.y);c.rotate(f.angle);c.globalAlpha=f.a;
        if(f.streak){
          const len=f.r*3.8;const g=c.createLinearGradient(0,-len,0,len);
          g.addColorStop(0,'rgba(255,255,255,0)');g.addColorStop(.48,'rgba(255,255,255,.78)');g.addColorStop(1,'rgba(255,255,255,0)');
          c.strokeStyle=g;c.lineWidth=Math.max(.7,f.r*.52);c.beginPath();c.moveTo(0,-len);c.lineTo(gust>0?-f.r*.9:0,len);c.stroke();
        }else if(f.depth>.78){
          const g=c.createRadialGradient(0,0,0,0,0,f.r*1.35);g.addColorStop(0,'rgba(255,255,255,.92)');g.addColorStop(.45,'rgba(245,252,255,.56)');g.addColorStop(1,'rgba(235,248,255,0)');
          c.fillStyle=g;c.beginPath();c.arc(0,0,f.r*1.35,0,Math.PI*2);c.fill();
        }else{
          c.fillStyle='rgba(252,254,255,.96)';c.beginPath();c.ellipse(0,0,f.r,f.r*(.72+f.depth*.2),0,0,Math.PI*2);c.fill();
        }
        c.restore();
      }
      raf=requestAnimationFrame(draw);
    }
    resize();raf=requestAnimationFrame(draw);addEventListener('resize',resize,{passive:true});
    document.addEventListener('visibilitychange',()=>{if(document.hidden)cancelAnimationFrame(raf);else{last=performance.now();raf=requestAnimationFrame(draw)}});
  }

  const smoke=document.querySelector('[data-yv4-fire-smoke]'),source=document.querySelector('[data-yv4-fire-source]');
  if(smoke&&source){
    const ctx=smoke.getContext('2d',{alpha:true,desynchronized:true});let w=1,h=1,dpr=1,last=0,raf=0,spawnTimer=0,ps=[];const TAU=Math.PI*2;const R=(a,b)=>a+Math.random()*(b-a);const isMobile=()=>matchMedia('(max-width:749px)').matches;
    const sprite=()=>{const cn=document.createElement('canvas');cn.width=cn.height=160;const x=cn.getContext('2d');for(let i=0;i<8;i++){const cx=80+R(-20,20),cy=80+R(-18,18),r=R(38,68),g=x.createRadialGradient(cx,cy,0,cx,cy,r);g.addColorStop(0,'rgba(245,250,252,.24)');g.addColorStop(.34,'rgba(225,238,242,.11)');g.addColorStop(.72,'rgba(204,222,227,.035)');g.addColorStop(1,'rgba(200,220,225,0)');x.fillStyle=g;x.beginPath();x.arc(cx,cy,r,0,TAU);x.fill()}return cn};const sprites=[sprite(),sprite(),sprite(),sprite()];
    function resize(){w=innerWidth;h=innerHeight;dpr=Math.min(devicePixelRatio||1,isMobile()?1.1:1.45);smoke.width=Math.round(w*dpr);smoke.height=Math.round(h*dpr);smoke.style.width=w+'px';smoke.style.height=h+'px';ctx.setTransform(dpr,0,0,dpr,0,0);ps=[]}
    function emitter(){const r=source.getBoundingClientRect();const x=Math.max(0,Math.min(w,r.left+r.width/2));const visible=r.top<h+80&&r.bottom>-80;return{x,y:visible?r.top+r.height/2:h+24}}
    function spawn(e){const m=isMobile();ps.push({x:e.x+R(-5,5),y:e.y+R(-3,5),vx:R(-3,3),vy:R(-33,-24),age:0,life:R(m?14:17,m?19:24),size:R(m?14:17,m?20:24),grow:R(3.4,5),phase:R(0,TAU),phase2:R(0,TAU),drift:R(-.45,.45),rot:R(0,TAU),spin:R(-.025,.025),alpha:R(.55,.9),sprite:sprites[(Math.random()*sprites.length)|0]})}
    function draw(t){if(!last)last=t;const dt=Math.min(.05,(t-last)/1000);last=t;ctx.clearRect(0,0,w,h);const e=emitter();spawnTimer+=dt;const every=isMobile()?.15:.105;while(spawnTimer>every){spawnTimer-=every;spawn(e)}const next=[];for(const p of ps){p.age+=dt;const u=p.age/p.life;if(u>=1||p.y<-220)continue;const rise=Math.max(0,Math.min(1,1-p.y/h));const flow=Math.sin(t*.00028+p.phase+p.y*.0034)*7.2+Math.sin(t*.00067+p.phase2-p.y*.009)*3.7+Math.sin(t*.00017+p.phase2*.5+p.y*.016)*1.8;p.vx+=(flow*(.35+rise*.85)+p.drift-p.vx*.16)*dt;p.vx=Math.max(-18,Math.min(18,p.vx));p.vy-=.7*dt;p.x+=p.vx*dt;p.y+=p.vy*dt;p.rot+=p.spin;const fade=Math.min(1,u/.09)*Math.min(1,(1-u)/.3);const size=p.size+p.grow*p.age;ctx.save();ctx.translate(p.x,p.y);ctx.rotate(p.rot);ctx.scale(1,1.18+u*.62);ctx.globalAlpha=fade*p.alpha*(isMobile()?.10:.13);ctx.drawImage(p.sprite,-size/2,-size/2,size,size);ctx.restore();next.push(p)}ps=next;raf=requestAnimationFrame(draw)}
    resize();raf=requestAnimationFrame(draw);addEventListener('resize',resize,{passive:true});document.addEventListener('visibilitychange',()=>{if(document.hidden)cancelAnimationFrame(raf);else{last=performance.now();raf=requestAnimationFrame(draw)}})
  }
})();

/* ==========================================================
   YETI SCRUBS V4.1 — LIVING WINTER CAMP INTERACTIONS
   ========================================================== */
(()=>{
  const q=(s,c=document)=>c.querySelector(s), qa=(s,c=document)=>[...c.querySelectorAll(s)];
  const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
  const home=document.body.classList.contains('yv4-winter-camp');
  if(!home) return;

  /* Day-to-night shift: the lower you travel, the deeper the camp-night tone. */
  const night=q('[data-yv4-nightfall]');
  let nightTick=false;
  const updateNight=()=>{
    if(nightTick)return; nightTick=true;
    requestAnimationFrame(()=>{
      const max=Math.max(1,document.documentElement.scrollHeight-innerHeight);
      const p=Math.max(0,Math.min(1,scrollY/max));
      document.documentElement.style.setProperty('--yv4-night',(0.02+p*.23).toFixed(3));
      nightTick=false;
    });
  };
  addEventListener('scroll',updateNight,{passive:true}); updateNight();

  /* Frosted product reveal: ice recedes when the camp gear comes into view. */
  const frozen=qa('.yv4-frost-card');
  if('IntersectionObserver' in window && !reduce){
    const io=new IntersectionObserver(entries=>entries.forEach(e=>{
      if(e.isIntersecting){setTimeout(()=>e.target.classList.add('yv4-thawed'),120+Math.random()*450);io.unobserve(e.target)}
    }),{threshold:.22});
    frozen.forEach(el=>io.observe(el));
  } else frozen.forEach(el=>el.classList.add('yv4-thawed'));

  /* Snow gathers on card/button edges over time. Tapping knocks a little loose. */
  const capTargets=qa('.yv3-btn,.yv3-mini-btn,.yv3-product-card,.yv4-newsletter-form button');
  capTargets.forEach(el=>el.classList.add('yv4-snow-cap'));
  if(!reduce){
    let cap=.30;
    const gather=setInterval(()=>{
      cap=Math.min(.88,cap+.085);
      document.documentElement.style.setProperty('--snow-cap',cap.toFixed(2));
      if(cap>=.88)clearInterval(gather);
    },3200);
    capTargets.forEach(el=>el.addEventListener('pointerdown',()=>{
      el.classList.add('is-knocked');
      setTimeout(()=>el.classList.remove('is-knocked'),750);
    }));
  }

  /* Wind gusts: infrequent global gusts push snow and bend the fire plume together. */
  if(!reduce){
    const gust=()=>{
      document.body.classList.add('yv4-wind-active');
      window.__yv4Wind=1;
      setTimeout(()=>{document.body.classList.remove('yv4-wind-active');window.__yv4Wind=0},2600+Math.random()*1300);
      setTimeout(gust,11500+Math.random()*14500);
    };
    setTimeout(gust,6500+Math.random()*5500);
  }

  /* Yeti footprints: subtle trail, appearing occasionally and fading like impressions being covered by snow. */
  const footLayer=q('[data-yv4-footprints]');
  function footprintTrail(){
    if(!footLayer || reduce)return;
    const fromLeft=Math.random()>.5;
    const baseY=innerHeight*(.72+Math.random()*.18);
    const count=7+Math.floor(Math.random()*4);
    for(let i=0;i<count;i++){
      setTimeout(()=>{
        const f=document.createElement('i'); f.className='yv4-print';
        const x=(fromLeft?1:-1)*(i*7.5)+(fromLeft?10:90)+(Math.random()*2-1);
        f.style.left=x+'vw';f.style.top=(baseY+(i%2?12:-4)+Math.random()*5)+'px';
        f.style.setProperty('--rot',(fromLeft?18:-18)+(Math.random()*12-6)+'deg');
        footLayer.appendChild(f);setTimeout(()=>f.remove(),8500);
      },i*500);
    }
    setTimeout(footprintTrail,19000+Math.random()*18000);
  }
  if(!reduce)setTimeout(footprintTrail,5500);

  /* Campfire: ambient embers, click-to-stoke flare, and temporary extra sparks. */
  const scene=q('[data-yv4-camp-scene]'), fire=q('[data-yv4-fire-button]'), emberField=q('[data-yv4-ember-field]');
  let flareUntil=0;
  function ember(strong=false){
    if(!emberField||reduce)return;
    const e=document.createElement('i');e.className='yv4-ember';
    const dir=(Math.random()-.5)*(strong?150:85), rise=-(90+Math.random()*(strong?190:125));
    e.style.setProperty('--dx',dir+'px');e.style.setProperty('--dy',rise+'px');e.style.setProperty('--dur',(1.4+Math.random()*1.5)+'s');
    e.style.width=e.style.height=(2+Math.random()*(strong?5:3))+'px';
    emberField.appendChild(e);setTimeout(()=>e.remove(),3300);
  }
  if(!reduce && emberField){setInterval(()=>{ember(false);if(Math.random()<.46)ember(false)},185)}
  const flare=()=>{
    if(!scene)return;
    scene.classList.remove('is-flaring'); void scene.offsetWidth; scene.classList.add('is-flaring');
    flareUntil=Date.now()+2600;
    for(let i=0;i<42;i++)setTimeout(()=>ember(true),i*28);
    setTimeout(()=>scene.classList.remove('is-flaring'),1200);
  };
  if(fire)fire.addEventListener('click',flare);

  /* Yeti Easter egg: clicking the Yeti answers, then stokes the fire. */
  const yeti=q('[data-yv4-yeti]'), msg=q('[data-yv4-yeti-message]');
  if(yeti)yeti.addEventListener('click',()=>{
    if(msg){msg.classList.add('is-visible');msg.setAttribute('aria-hidden','false');setTimeout(()=>{msg.classList.remove('is-visible');msg.setAttribute('aria-hidden','true')},2200)}
    flare();
  });

  /* Rare smoke-mark Easter egg. Brief enough that it feels discovered. */
  const mark=q('[data-yv4-smoke-mark]');
  function smokeMark(){
    if(!mark||reduce)return;
    const fireScene=q('[data-yv4-campfire]');
    if(fireScene){const r=fireScene.getBoundingClientRect(); if(r.top<innerHeight*.9 && r.bottom>0){mark.classList.add('is-visible');setTimeout(()=>mark.classList.remove('is-visible'),4200)}}
    setTimeout(smokeMark,36000+Math.random()*48000);
  }
  if(!reduce)setTimeout(smokeMark,19000+Math.random()*15000);
})();


/* ==========================================================
   YETI SCRUBS V4.2 — TRUE LIVE FIRE / ROBUST SNOW DETAILS
   ========================================================== */
(()=>{
  const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(reduce) return;
  const q=(s,c=document)=>c.querySelector(s), qa=(s,c=document)=>[...c.querySelectorAll(s)];

  /* Inject physical snow piles into the surfaces that should accumulate snow. */
  const snowTargets=qa('.yv3-btn,.yv3-mini-btn,.yv3-product-card,.yv4-category,.yv4-newsletter-form button');
  snowTargets.forEach(el=>{
    el.classList.add('yv4-snow-cap');
    if(!el.querySelector(':scope > .yv4-snow-pile')){const pile=document.createElement('i');pile.className='yv4-snow-pile';pile.setAttribute('aria-hidden','true');el.appendChild(pile)}
  });
  document.documentElement.style.setProperty('--snow-cap','.34');
  let snowLevel=.34;
  const snowGather=setInterval(()=>{snowLevel=Math.min(.88,snowLevel+.07);document.documentElement.style.setProperty('--snow-cap',snowLevel.toFixed(2));if(snowLevel>=.88)clearInterval(snowGather)},3000);

  /* Live flame field: warm turbulent flame tongues drawn over the real photographed fire. */
  const canvas=q('[data-yv4-live-fire]'), scene=q('[data-yv4-camp-scene]');
  if(canvas && scene){
    const cx=canvas.getContext('2d',{alpha:true});
    let w=0,h=0,dpr=1,parts=[],sparks=[],last=0,raf=0,flare=0;
    const R=(a,b)=>a+Math.random()*(b-a), TAU=Math.PI*2;
    function resize(){const r=canvas.getBoundingClientRect();w=Math.max(80,r.width);h=Math.max(80,r.height);dpr=Math.min(devicePixelRatio||1,1.5);canvas.width=Math.round(w*dpr);canvas.height=Math.round(h*dpr);cx.setTransform(dpr,0,0,dpr,0,0)}
    function flame(strong=false){
      const power=strong?1.28:1;
      parts.push({x:w*(.50+R(-.20,.20)),y:h*(.88+R(-.04,.03)),vx:R(-10,10),vy:R(-74,-42)*power,age:0,life:R(.55,1.28),r:R(15,32)*power,phase:R(0,TAU),heat:R(0,1)});
    }
    function spark(strong=false){sparks.push({x:w*(.50+R(-.18,.18)),y:h*.83,vx:R(-24,24)*(strong?1.35:1),vy:R(-120,-68)*(strong?1.25:1),age:0,life:R(.55,1.6),r:R(1.1,strong?3.3:2.2)})}
    function draw(t){
      if(!last)last=t;const dt=Math.min(.04,(t-last)/1000);last=t;cx.clearRect(0,0,w,h);cx.globalCompositeOperation='lighter';
      const activeFlare=scene.classList.contains('is-flaring'); if(activeFlare)flare=Math.min(1,flare+dt*5);else flare=Math.max(0,flare-dt*1.7);
      const density=4+Math.round(flare*4);for(let i=0;i<density;i++)if(Math.random()<.46)flame(flare>.25);if(Math.random()<.34+flare*.46)spark(flare>.2);
      const wind=(window.__yv4Wind||0)*22;
      const np=[];
      for(const p of parts){p.age+=dt;if(p.age>=p.life)continue;const u=p.age/p.life;p.vx+=(Math.sin(t*.006+p.phase+p.y*.035)*18+wind-p.vx*.9)*dt;p.vy-=R(2,7)*dt;p.x+=p.vx*dt;p.y+=p.vy*dt;const rr=p.r*(1-u*.48)*(1+flare*.16);const a=Math.sin(Math.PI*Math.min(1,u))*0.58*(1-u*.25);
        const g=cx.createRadialGradient(p.x,p.y,0,p.x,p.y,rr);g.addColorStop(0,`rgba(255,255,215,${a*.95})`);g.addColorStop(.18,`rgba(255,214,85,${a})`);g.addColorStop(.48,`rgba(255,103,19,${a*.72})`);g.addColorStop(.75,`rgba(210,31,5,${a*.28})`);g.addColorStop(1,'rgba(140,15,0,0)');cx.fillStyle=g;cx.beginPath();cx.ellipse(p.x,p.y,rr*.52,rr*1.28,Math.sin(p.phase+t*.003)*.16,0,TAU);cx.fill();np.push(p)}parts=np;
      const ns=[];for(const s of sparks){s.age+=dt;if(s.age>=s.life)continue;const u=s.age/s.life;s.vx+=(wind*.18)*dt;s.vy+=16*dt;s.x+=s.vx*dt;s.y+=s.vy*dt;cx.globalAlpha=(1-u)*.95;cx.fillStyle=u<.55?'#ffd86c':'#ff6a1d';cx.shadowColor='#ff6a16';cx.shadowBlur=8;cx.beginPath();cx.arc(s.x,s.y,s.r*(1-u*.35),0,TAU);cx.fill();cx.shadowBlur=0;ns.push(s)}sparks=ns;cx.globalAlpha=1;cx.globalCompositeOperation='source-over';raf=requestAnimationFrame(draw)}
    resize();raf=requestAnimationFrame(draw);addEventListener('resize',resize,{passive:true});document.addEventListener('visibilitychange',()=>{if(document.hidden)cancelAnimationFrame(raf);else{last=performance.now();raf=requestAnimationFrame(draw)}})
  }

  /* Make sure the very first footprint trail is unmistakable, then continue organically. */
  const layer=q('[data-yv4-footprints]');
  function obviousTrail(){
    if(!layer)return;const left=Math.random()>.5, y=innerHeight*.70;for(let i=0;i<11;i++)setTimeout(()=>{const f=document.createElement('i');f.className='yv4-print';f.style.left=(left?7+i*7.7:91-i*7.7)+'vw';f.style.top=(y+(i%2?15:-5))+'px';f.style.setProperty('--rot',(left?14:-14)+(Math.random()*8-4)+'deg');layer.appendChild(f);setTimeout(()=>f.remove(),12500)},i*380)
  }
  setTimeout(obviousTrail,850);
})();

/* V4.2R Camp Loop hotfix — robust fire interaction and visible stoke response. */
(()=>{
  const section=document.querySelector('.yv4-campfire--video');
  if(!section)return;
  const fire=section.querySelector('[data-yv4-fire-button]');
  const scene=section.querySelector('[data-yv4-camp-scene]');
  const words=section.querySelector('[data-yv42-stay-wild]');
  const embers=section.querySelector('[data-yv4-ember-field]');
  if(!fire||!scene)return;
  let resetTimer=0;

  const burst=()=>{
    if(!embers)return;
    for(let i=0;i<54;i++){
      setTimeout(()=>{
        const e=document.createElement('i');
        e.className='yv4-ember';
        e.style.left=(65+Math.random()*7)+'%';
        e.style.top=(70+Math.random()*6)+'%';
        e.style.setProperty('--dx',((Math.random()-.5)*190)+'px');
        e.style.setProperty('--dy',(-(115+Math.random()*230))+'px');
        e.style.setProperty('--dur',(1.25+Math.random()*1.55)+'s');
        const s=2+Math.random()*5;e.style.width=e.style.height=s+'px';
        embers.appendChild(e);
        setTimeout(()=>e.remove(),3200);
      },i*20);
    }
  };

  const stoke=()=>{
    clearTimeout(resetTimer);
    scene.classList.remove('is-stoked');
    void scene.offsetWidth;
    scene.classList.add('is-stoked');
    burst();
    if(words){
      words.classList.remove('is-visible');
      void words.offsetWidth;
      setTimeout(()=>words.classList.add('is-visible'),260);
    }
    resetTimer=setTimeout(()=>{
      scene.classList.remove('is-stoked');
      if(words)words.classList.remove('is-visible');
    },5000);
  };

  /* Capture phase makes this reliable even if another theme script stops bubbling. */
  fire.addEventListener('click',(event)=>{
    event.preventDefault();
    event.stopPropagation();
    stoke();
  },true);
  fire.addEventListener('keydown',(event)=>{
    if(event.key==='Enter'||event.key===' '){event.preventDefault();stoke()}
  });
})();


/* ==========================================================
   YETI V4.3 EXPERIENCE LAYER
   ========================================================== */
(()=>{
  const q=(s,c=document)=>c.querySelector(s),qa=(s,c=document)=>[...c.querySelectorAll(s)];

  /* Find Your Yeti — two-step scent/routine explorer */
  qa('[data-yv4-quiz]').forEach(quiz=>{
    const screens=qa('[data-yv4-quiz-screen]',quiz),meter=q('[data-yv4-quiz-meter]',quiz),step=q('[data-yv4-quiz-step]',quiz);let scent='';
    const show=n=>{screens.forEach(x=>x.classList.toggle('is-active',x.dataset.yv4QuizScreen==String(n)));if(meter)meter.style.width=n===1?'50%':'100%';if(step)step.textContent=n===1?'STEP 1 OF 2':n===2?'STEP 2 OF 2':'MATCH FOUND'};
    qa('[data-yv4-scent]',quiz).forEach(b=>b.addEventListener('click',()=>{scent=b.dataset.yv4Scent;show(2)}));
    qa('[data-yv4-goal]',quiz).forEach(b=>b.addEventListener('click',()=>{const map={fresh:'FRESH + CLEAN',woodsy:'WOODSY + RUGGED',sweet:'WARM + COZY',clean:'CLEAN + EVERYDAY'};q('[data-yv4-quiz-result-title]',quiz).textContent=map[scent]||'FOUND IT.';q('[data-yv4-quiz-result-copy]',quiz).textContent='Start here, then follow the scent trail that fits you best.';q('[data-yv4-quiz-result-link]',quiz).href=b.dataset.yv4Goal+'?profile='+encodeURIComponent(scent);show(3)}));
    q('[data-yv4-quiz-back]',quiz)?.addEventListener('click',()=>show(1));q('[data-yv4-quiz-restart]',quiz)?.addEventListener('click',()=>{scent='';show(1)});
  });

  /* Profile-aware collection filtering from Find Your Yeti. Uses product metafields or scent-family:* tags. */
  qa('[data-yv4-profile-grid]').forEach(grid=>{
    const profile=(new URLSearchParams(location.search).get('profile')||'').toLowerCase().trim();
    if(!profile)return;
    const cards=qa('[data-yv4-family]',grid);
    let shown=0;
    cards.forEach(c=>{
      const families=(c.dataset.yv4Family||'').toLowerCase().split(/[|,]/).map(x=>x.trim()).filter(Boolean);
      const match=families.includes(profile);
      c.hidden=!match;
      if(match)shown++;
    });
    grid.classList.add('is-yv4-profile-filtered');
    if(!shown){
      const msg=document.createElement('div');
      msg.className='yv4-profile-empty';
      msg.innerHTML='<strong>NO EXACT MATCH IN THIS CATEGORY.</strong><span>Try another routine step or start the scent finder again.</span><a href="/#find-your-yeti">FIND MY YETI AGAIN →</a>';
      grid.after(msg);
    }
  });

  /* Product recommendation section lazy loads Shopify's recommendation endpoint. */
  qa('[data-yv4-recommendations]').forEach(async section=>{if(section.innerHTML.trim())return;try{const r=await fetch(section.dataset.url);if(!r.ok)return;const html=await r.text(),doc=new DOMParser().parseFromString(html,'text/html'),fresh=doc.querySelector('[data-yv4-recommendations]');if(fresh&&fresh.innerHTML.trim())section.innerHTML=fresh.innerHTML}catch(_){}});

  /* AJAX cart drawer */
  const drawer=q('[data-yv4-cart-drawer]'),overlay=q('[data-yv4-cart-overlay]');
  const money=c=>new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:'USD'}).format(c/100);
  const openCart=()=>{if(!drawer||!overlay)return;overlay.hidden=false;requestAnimationFrame(()=>{overlay.classList.add('is-open');drawer.classList.add('is-open')});drawer.setAttribute('aria-hidden','false');document.body.classList.add('yv4-cart-open')};
  const closeCart=()=>{if(!drawer||!overlay)return;overlay.classList.remove('is-open');drawer.classList.remove('is-open');drawer.setAttribute('aria-hidden','true');document.body.classList.remove('yv4-cart-open');setTimeout(()=>{overlay.hidden=true},320)};
  q('[data-yv4-cart-close]')?.addEventListener('click',closeCart);overlay?.addEventListener('click',closeCart);document.addEventListener('keydown',e=>{if(e.key==='Escape')closeCart()});
  qa('[data-yv4-cart-open]').forEach(a=>a.addEventListener('click',e=>{if(drawer){e.preventDefault();openCart()}}));
  const renderCart=cart=>{if(!drawer)return;const items=q('[data-yv4-cart-items]',drawer),foot=q('[data-yv4-cart-foot]',drawer);q('[data-yv4-cart-count]',drawer).textContent=cart.item_count;qa('[data-yv4-header-count]').forEach(x=>x.textContent=cart.item_count);q('[data-yv4-cart-total]',drawer).textContent=money(cart.total_price);const bar=q('[data-yv4-shipping-bar]',drawer),txt=q('[data-yv4-shipping-text]',drawer);bar.style.width='100%';txt.textContent='FREE U.S. SHIPPING — NO MINIMUM';foot.hidden=cart.item_count===0;if(!cart.item_count){items.innerHTML='<div class="yv4-cart-empty"><span>△</span><h3>YOUR BAG IS WIDE OPEN.</h3><p>Load it up for the trail.</p><a href="/collections/all" class="yv3-btn yv3-btn--ice">SHOP ALL</a></div>';return}items.innerHTML=cart.items.map(it=>`<div class="yv4-cart-item" data-key="${it.key}">${it.image?`<a href="${it.url}"><img src="${it.image}" alt=""></a>`:''}<div><a class="yv4-cart-item__title" href="${it.url}">${it.product_title}</a>${it.variant_title&&it.variant_title!=='Default Title'?`<small>${it.variant_title}</small>`:''}<div class="yv4-cart-item__bottom"><span>${money(it.final_line_price)}</span><div class="yv4-qty"><button type="button" data-yv4-qty="-1">−</button><b>${it.quantity}</b><button type="button" data-yv4-qty="1">+</button></div></div></div></div>`).join('');bindQty()};
  const getCart=()=>fetch('/cart.js',{headers:{Accept:'application/json'}}).then(r=>r.json());
  const bindQty=()=>qa('[data-yv4-qty]',drawer).forEach(btn=>btn.onclick=async()=>{const row=btn.closest('[data-key]'),qty=parseInt(q('b',btn.parentElement).textContent,10)+parseInt(btn.dataset.yv4Qty,10);try{const r=await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:row.dataset.key,quantity:Math.max(0,qty)})});renderCart(await r.json())}catch(_){location.href='/cart'}});bindQty();
  qa('.yv3-quick-form,.yv3-product-form').forEach(form=>{form.addEventListener('submit',async e=>{if(!drawer)return;e.preventDefault();const btn=form.querySelector('[type="submit"]'),old=btn?.innerHTML;if(btn){btn.disabled=true;btn.textContent='ADDING…'}try{const r=await fetch('/cart/add.js',{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});if(!r.ok)throw new Error();const cart=await getCart();renderCart(cart);openCart();if(btn){btn.innerHTML='ADDED ✓';setTimeout(()=>{btn.innerHTML=old;btn.disabled=false},900)}}catch(_){if(btn){btn.innerHTML=old;btn.disabled=false}form.submit()}} ,true)});

  /* Campfire reward: every third manual stoke, once per session. */
  const fire=q('[data-yv4-fire-button]'),reward=q('[data-yv4-camp-reward]');if(fire&&reward){let n=0,shown=false;fire.addEventListener('click',()=>{n++;if(n>=3&&!shown){shown=true;reward.hidden=false;requestAnimationFrame(()=>reward.classList.add('is-visible'));setTimeout(()=>{reward.classList.remove('is-visible');setTimeout(()=>reward.hidden=true,500)},5200)}})}

  /* tactile microinteractions — device vibration is only used when supported and user initiated */
  qa('.yv3-btn,.yv3-mini-btn,[data-yv4-fire-button],[data-yv4-scent],[data-yv4-goal]').forEach(el=>el.addEventListener('pointerup',()=>{if(navigator.vibrate&&matchMedia('(pointer:coarse)').matches)navigator.vibrate(8)},{passive:true}));
})();

/* Yeti V5.1 conversion layer */
(()=>{const q=(s,c=document)=>c.querySelector(s),qa=(s,c=document)=>[...c.querySelectorAll(s)];
  const sticky=q('[data-yv51-sticky]'), mainAdd=q('[data-yv3-add]'), stickyAdd=q('[data-yv51-sticky-add]'), variant=q('[data-yv3-variant-select]');
  if(sticky&&mainAdd&&stickyAdd){const sync=()=>{stickyAdd.disabled=mainAdd.disabled;const p=q('[data-yv3-price]');const sp=q('[data-yv51-sticky-price]');if(p&&sp)sp.textContent=p.textContent};const vis=()=>{const r=mainAdd.getBoundingClientRect();sticky.classList.toggle('is-visible',r.bottom<0)};addEventListener('scroll',vis,{passive:true});vis();variant?.addEventListener('change',sync);stickyAdd.addEventListener('click',()=>mainAdd.click());sync()}
  const drawer=q('[data-yv4-cart-drawer]'), box=q('[data-yv51-cart-upsell]'), camp=q('[data-yv58-camp-progress]');
  const updateCamp=cart=>{if(!camp)return;const n=cart.item_count||0;if(!n){camp.hidden=true;return}camp.hidden=false;const bar=q('[data-yv58-camp-bar]',camp),status=q('[data-yv58-camp-status]',camp),copy=q('[data-yv58-camp-copy]',camp),action=q('[data-yv58-camp-action]',camp);bar.style.width=Math.min(100,n/4*100)+'%';if(n>=4){status.textContent='15% CAMP SAVINGS UNLOCKED';copy.textContent='Your camp is fully loaded. Apply your 15% camp savings now.';action.textContent='APPLY 15% + CHECKOUT →';action.href='/discount/BUILDCAMP15?redirect=/checkout'}else if(n===3){status.textContent='10% UNLOCKED · ADD 1 MORE FOR 15%';copy.textContent='You unlocked 10%. Apply it now or add one more item to level up to 15%.';action.textContent='APPLY 10% + CHECKOUT →';action.href='/discount/BUILDCAMP10?redirect=/checkout'}else{const need=3-n;status.textContent=`${need} MORE ${need===1?'ITEM':'ITEMS'} · UNLOCK 10%`;copy.textContent=`Pack ${need} more ${need===1?'item':'items'} to unlock 10% off. Four items unlocks 15%.`;action.textContent='ADD TO YOUR CAMP →';action.href='/#build-your-camp'}};
  if(drawer&&box){const updateUpsell=cart=>{updateCamp(cart);if(!cart.item_count){box.hidden=true;return}const titles=cart.items.map(i=>(i.product_title||'').toLowerCase()).join(' | ');let copy='Pair your Yeti with the next step in the routine.',href='/collections/all',label='SHOP MORE YETI →';if(titles.includes('salt scrub')||titles.includes('altitude')||titles.includes('fragrance free')){copy='Scrub loaded. Add lotion to keep the routine going.';href='/collections/lotion';label='ADD LOTION →'}else if(titles.includes('bath soak')){copy='Soak loaded. Pair it with a matching salt scrub.';href='/collections/scrubs';label='ADD A SCRUB →'}else if(titles.includes('lotion')){copy='Lotion loaded. Pair it with a salt scrub.';href='/collections/scrubs';label='ADD A SCRUB →'}else if(titles.includes('body oil')){copy='Body oil loaded. Pair it with lotion for the full finish.';href='/collections/lotion';label='ADD LOTION →'}copy=`Free U.S. shipping is on us. ${copy}`;q('[data-yv51-upsell-copy]',box).textContent=copy;const a=q('[data-yv51-upsell-link]',box);a.href=href;a.textContent=label;box.hidden=false};
    const oldFetch=window.fetch;window.fetch=async function(...args){const res=await oldFetch.apply(this,args);try{const u=String(args[0]);if(u.includes('/cart.js')||u.includes('/cart/change.js')){res.clone().json().then(c=>{if(c&&typeof c.item_count==='number')updateUpsell(c)}).catch(()=>{})}}catch(_){}return res};oldFetch('/cart.js',{headers:{Accept:'application/json'}}).then(r=>r.json()).then(c=>{updateCamp(c);updateUpsell(c)}).catch(()=>{})}
})();

/* V5.5 Build Your Camp */
(()=>{
  const root=document.querySelector('[data-yv55-builder]'); if(!root)return;
  const picks=[...root.querySelectorAll('[data-yv55-pick]')], itemsEl=root.querySelector('[data-yv55-items]'), empty=root.querySelector('[data-yv55-empty]'), totalEl=root.querySelector('[data-yv55-total]'), progress=root.querySelector('[data-yv55-progress]'), unlock=root.querySelector('[data-yv55-unlock]'), save=root.querySelector('[data-yv55-save]'), add=root.querySelector('[data-yv55-add]');
  const selected=new Map();
  const money=c=>new Intl.NumberFormat(undefined,{style:'currency',currency:'USD'}).format(c/100);
  const render=()=>{const vals=[...selected.values()],n=vals.length,total=vals.reduce((a,x)=>a+x.price,0);empty.hidden=n>0;itemsEl.innerHTML=vals.map(x=>`<div class="yv55-loadout__item"><b>${x.title}</b><span>${money(x.price)}</span></div>`).join('');totalEl.textContent=money(total);progress.style.width=Math.min(100,n/4*100)+'%';let pct=n>=4?15:n>=3?10:0;save.textContent=pct?`${pct}% CAMP SAVINGS UNLOCKED`:'0% CAMP SAVINGS';unlock.textContent=n<3?`Add ${3-n} more item${3-n===1?'':'s'} to unlock 10% savings`:n===3?'Add 1 more item to unlock 15% savings':'15% savings tier unlocked';add.disabled=n<3;add.innerHTML=n<3?'ADD 3+ ITEMS TO CONTINUE':'ADD LOADOUT TO BAG <b>→</b>';};
  picks.forEach(btn=>btn.addEventListener('click',()=>{const id=btn.dataset.variant;if(selected.has(id)){selected.delete(id);btn.classList.remove('is-selected')}else{selected.set(id,{id:parseInt(id,10),title:btn.dataset.title,price:parseInt(btn.dataset.price,10)});btn.classList.add('is-selected')}render()}));
  add.addEventListener('click',async()=>{if(selected.size<3)return;const old=add.innerHTML;add.disabled=true;add.textContent='PACKING YOUR CRATE…';try{const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[...selected.values()].map(x=>({id:x.id,quantity:1}))})});if(!r.ok)throw new Error();const code=selected.size>=4?'BUILDCAMP15':'BUILDCAMP10';add.innerHTML='SAVINGS APPLIED ✓';setTimeout(()=>location.href=`/discount/${code}?redirect=/cart`,450)}catch(e){add.innerHTML=old;add.disabled=false}});render();
})();

/* V5.9 mobile sticky purchase bar */
(()=>{
  const bar=document.querySelector('[data-yv59-buybar]');
  const form=document.querySelector('.yv3-product-form');
  const mainAdd=form&&form.querySelector('[data-yv3-add]');
  if(!bar||!form||!mainAdd)return;
  document.body.classList.add('yv59-has-buybar');
  const stickyAdd=bar.querySelector('[data-yv59-add]');
  const stickyPrice=bar.querySelector('[data-yv59-price]');
  const select=form.querySelector('[data-yv3-variant-select]');
  const sync=()=>{
    stickyAdd.disabled=mainAdd.disabled;
    stickyAdd.textContent=mainAdd.disabled?'SOLD OUT':'ADD TO BAG +';
    const price=document.querySelector('[data-yv3-price]'); if(price&&stickyPrice)stickyPrice.textContent=price.textContent;
  };
  if(select)select.addEventListener('change',()=>setTimeout(sync,0));
  stickyAdd.addEventListener('click',()=>{sync();if(!stickyAdd.disabled)mainAdd.click()});
  const show=()=>{if(innerWidth>760){bar.classList.remove('is-visible');return}const r=mainAdd.getBoundingClientRect();const visible=r.top<innerHeight&&r.bottom>0;bar.classList.toggle('is-visible',!visible&&scrollY>180);bar.setAttribute('aria-hidden',visible?'true':'false')};
  addEventListener('scroll',show,{passive:true});addEventListener('resize',show,{passive:true});sync();show();
})();

/* V6.0 guided starter -> builder */
(()=>{
  const root=document.querySelector('[data-yv55-builder]'); if(!root)return;
  const steps=[...root.querySelectorAll('.yv55-builder-step')];
  const markNext=()=>{steps.forEach(x=>x.classList.remove('is-yv60-next'));const counts=steps.map(s=>s.querySelectorAll('.yv55-pick.is-selected').length);const idx=counts[0]===0?0:counts[1]===0?1:counts[2]===0?2:-1;if(idx>=0)steps[idx].classList.add('is-yv60-next')};
  root.addEventListener('click',()=>setTimeout(markNext,0)); markNext();
  document.querySelectorAll('[data-yv60-starter]').forEach(a=>a.addEventListener('click',()=>{const id=a.dataset.yv60Starter;const pick=root.querySelector(`[data-yv55-pick][data-variant="${id}"]`);if(pick&&!pick.classList.contains('is-selected'))pick.click();setTimeout(()=>root.scrollIntoView({behavior:'smooth',block:'start'}),40)}));
})();
